import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-border bg-background" data-id="element-121">
      <div className="max-w-6xl mx-auto text-center" data-id="element-122">
        <div className="text-2xl font-bold text-white mb-4" data-id="element-123">
          🛴 SABER-DIGITAL™
        </div>
        <p className="text-muted max-w-md mx-auto mb-8" data-id="element-124">
          El sistema N°1 de conocimiento técnico para usuarios de scooters
          eléctricos en Argentina.
          <br data-id="element-125" />
          <br data-id="element-126" />
          Porque tener un scooter eléctrico no debería costarte una fortuna en
          service ni dejarte tirado en la calle.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-12" data-id="element-127">
          <a href="mailto:soportesaberdigital0@gmail.com" className="hover:text-brand transition-colors" data-id="element-128">
            📧 soportesaberdigital0@gmail.com
          </a>
          <a href="#" className="hover:text-brand transition-colors" data-id="element-129">
            📲 @saberdigital
          </a>
          <a href="#" className="hover:text-brand transition-colors" data-id="element-130">
            🌐 www.saber-digital.com
          </a>
        </div>

        <div className="text-xs text-gray-600 mb-8" data-id="element-131">
          © Saber-Digital™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>

        <div className="text-brand/50 font-heading italic" data-id="element-132">
          🛴 "El scooter que entendés, dura el doble y te cuesta la mitad."
        </div>
      </div>
    </footer>;
}